
(function() {
  var result = { translations: { "ru": { "i18n": { "duration": { "seconds": "{{ seconds }} \u0441", "minutes": "{{ minutes }} \u043C\u0438\u043D", "hours": "{{ hours }} \u0447", "hoursAndMinutes": "{{ hours }} \u0447 {{ minutes }} \u043C\u0438\u043D", "days": "{{ days }} \u0434\u043D.", "shortForm": { "seconds": "{{ seconds }}\u0441", "minutes": "{{ minutes }}\u043C", "hours": "{{ hours }}\u0447", "days": "{{ days }}\u0434", "hoursAndMinutes": "{{ hours }}\u0447 {{ minutes }}\u043C" } }, "dateTime": { "quarterAndYear": "\u041A\u0432.{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \u0434\u043E\u0431\u0430\u0432. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ru": "static-7.932"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.932",
    "ar-eg": "static-7.932",
    "bg": "static-7.932",
    "bn": "static-7.932",
    "ca-es": "static-7.932",
    "cs": "static-7.932",
    "da": "static-7.932",
    "de": "static-7.932",
    "el": "static-7.932",
    "en-gb": "static-7.932",
    "en": "static-7.932",
    "es-mx": "static-7.932",
    "es": "static-7.932",
    "fi": "static-7.932",
    "fr-ca": "static-7.932",
    "fr": "static-7.932",
    "he-il": "static-7.932",
    "hr": "static-7.932",
    "hu": "static-7.932",
    "id": "static-7.932",
    "it": "static-7.932",
    "ja": "static-7.932",
    "ko": "static-7.932",
    "lt": "static-7.932",
    "ms": "static-7.932",
    "nl": "static-7.932",
    "no": "static-7.932",
    "pl": "static-7.932",
    "pt-br": "static-7.932",
    "pt-pt": "static-7.932",
    "ro": "static-7.932",
    "ru": "static-7.932",
    "sk": "static-7.932",
    "sl": "static-7.932",
    "sv": "static-7.932",
    "th": "static-7.932",
    "tl": "static-7.932",
    "tr": "static-7.932",
    "uk": "static-7.932",
    "vi": "static-7.932",
    "x-pseudo": "static-7.932",
    "zh-cn": "static-7.932",
    "zh-hk": "static-7.932",
    "zh-tw": "static-7.932"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ru', {version: 'static-7.932'}); }
})();


